export default __webpack_public_path__ + "static/media/me-todo-de-pago.995f34e8.png";